module.exports = __webpack_public_path__ + "static/img/bg_card.6bdc220.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bts-2026-sale/bg_card.gif
// module id = Fxth
// module chunks = 2